const SvgDataDriven1 = (props) => (
  <>
    <path d="M16 16h352v352H16z" fill={props.p10} />
  </>
);

export default SvgDataDriven1;
